import { Navigate, NavLink, Outlet, Route, Routes, useParams } from 'react-router-dom'
import PrecursorMaterials from './pages/precursor-material-suppliers/components/PrecursorMaterials'
import { H2, Tab } from '@/common'
import PreconsumerScrapMaterialsBalance from './pages/preconsumer-scrap-balance'
import useI18n from '@/shared/hooks/useI18n'
import { useInstallations } from '@/features/installations/hooks/useInstallations'
import { Container, LoadingScreen } from '@/shared/components'

const MaterialManagementTabs = () => {
  const { t } = useI18n()
  return (
    <div className="flex gap-4 border-b">
      <NavLink to="precursors" relative="path">
        {({ isActive }) => <Tab isActive={isActive}>{t('materials:layout.tabs.precursors')}</Tab>}
      </NavLink>
      <NavLink to="scrap" relative="path">
        {({ isActive }) => (
          <Tab isActive={isActive}>{t('materials:layout.tabs.preconsumerScrap')}</Tab>
        )}
      </NavLink>
    </div>
  )
}

export default function Materials() {
  const { t } = useI18n()
  const installationId = useParams<{ installationId: string }>().installationId!
  const { data: installations, isLoading } = useInstallations()
  const installation = installations?.find(installation => installation.id === installationId)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!installation) {
    return <Navigate to="/dashboard" />
  }

  const header = (
    <header className="mb-8">
      <H2>{t('materials:layout.title')}</H2>
    </header>
  )

  const tabs = <MaterialManagementTabs />

  const layout = (
    <div>
      <Container>
        <>
          {header}
          {tabs}
        </>
        <Outlet />
      </Container>
    </div>
  )

  return (
    <Routes>
      <Route path="/" element={layout}>
        <Route index element={<Navigate to="precursors" replace />} />
        <Route
          path="/precursors"
          element={
            <PrecursorMaterials
              installationId={installationId}
              reportingPeriods={installation.reportingPeriods}
              reportingPeriodBasis={installation.basisForReportingPeriod}
            />
          }
        />
        <Route
          path="/scrap"
          element={
            <PreconsumerScrapMaterialsBalance
              installationId={installationId}
              reportingPeriods={installation.reportingPeriods}
              reportingPeriodBasis={installation.basisForReportingPeriod}
            />
          }
        />
      </Route>
    </Routes>
  )
}
